import React, { createContext, useContext, useState } from "react";

type AppContextType = {
  nameOriginCountry: string;
  setNameOriginCountry: (country: string) => void;
  language: string;
  setLanguage: (lang: string) => void;
};

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [nameOriginCountry, setNameOriginCountry] = useState("spain"); // Default value is "Spain"
  const [language, setLanguage] = useState("es"); // Default language is English

  return (
    <AppContext.Provider
      value={{ nameOriginCountry, setNameOriginCountry, language, setLanguage }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};
